var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_429_7156)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_429_7156",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H40V40H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_429_7156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8281 20C38.8281 30.3985 30.3984 38.8281 20 38.8281C9.60133 38.8281 1.17188 30.3985 1.17188 20C1.17188 9.60133 9.60133 1.17188 20 1.17188C30.3984 1.17188 38.8281 9.60133 38.8281 20Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5313 17.4893C27.5313 21.6486 24.1596 25.0205 20.0001 25.0205C15.8404 25.0205 12.4688 21.6486 12.4688 17.4893C12.4688 13.33 15.8404 9.95809 20.0001 9.95809C24.1596 9.95809 27.5313 13.33 27.5313 17.4893Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7666 35.1112C9.36895 29.4391 14.1683 25.0207 20 25.0207C25.8318 25.0207 30.631 29.4395 31.2332 35.1113",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_7156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic-user.513f80e94431873b81fb978169963685.svg";
export { ForwardRef as ReactComponent };